import { useEffect, useState } from 'react';
import { AsyncButton } from '@/components/common/AsyncButton';
import { BsTooltip } from '@/components/common/BsTooltip';

interface BufferControlProps {
  amount: number;
  onSave: (amount: number) => Promise<void>;
}

// Buffer Amount control for one Internal/External sub-pill: label + number input
// (positives only, 2-dec) + Save button. Mirrors the legacy buffer row.
export function BufferControl({ amount, onSave }: BufferControlProps) {
  const [value, setValue] = useState(String(amount ?? 0));

  useEffect(() => {
    setValue(String(amount ?? 0));
  }, [amount]);

  async function save() {
    const parsed = Number(value.replace(/,/g, '')) || 0;
    await onSave(parsed);
  }

  return (
    <div className="d-flex align-items-end gap-2">
      <div>
        <label className="form-label mb-1 d-block">Buffer Amount</label>
        <BsTooltip
          title="This amount is added to Client Liabilities when calculating the Excess/Shortfall."
          className="d-inline-block"
        >
          <input
            type="number"
            min={0}
            step="0.01"
            className="form-control form-control-sm recon-buffer-input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </BsTooltip>
      </div>
      <AsyncButton className="btn btn-sm btn-primary" icon="fa fa-save" onClick={save}>
        Save
      </AsyncButton>
    </div>
  );
}
